import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import GridContainer from '../global/GridContainer/GridContainer';
import SearchInput from '../../components/SearchInput';
import EventsItem from './components/EventsItem';
import EventsMap from './components/EventsMap';
import MapView from '../Icons/MapView';

const Events = ({ events, organisation, getUserOrganisation, getEvents }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [isMapView, setIsMapView] = useState(false);

  useEffect(() => {
    getEvents({ search: '' });
    getUserOrganisation();
  }, []);

  useEffect(() => {
    const mapView = searchParams.get('mapview') || false;
    setIsMapView(mapView === 'true' ? true : false);
  }, [searchParams]);

  const onMapPressed = () => {
    setIsMapView(!isMapView);
  };

  const onSearch = (searchText) => {
    setSearch(searchText);
    getEvents({ search: searchText });
  };

  return (
    <div className="events-container">
      <GridContainer>
        <div className="events-container--upper">
          <div className="events-container-header-back-link" onClick={() => navigate('/home')}>
            <FontAwesomeIcon
              icon={['fas', 'chevron-left']}
              className="feed-group-header-back-link-icon"
            />
            {'Go back'}
          </div>
          <h3 className="title m-0">Events Listings</h3>
          <SearchInput submit={onSearch} placeholder="Search Events" />
        </div>
        {isMapView ? (
          <EventsMap organisation={organisation} events={events} />
        ) : (
          <div className="events-container-hub-list">
            {events.map((event) => {
              return (
                <EventsItem
                  id={event.id}
                  title={event.title}
                  startTime={event.start_time}
                  endTime={event.end_time}
                  location={event.location}
                />
              );
            })}
            {!events.length && !search ? (
              <p>No events available at the moment.</p>
            ) : null}
            {!events.length && search ? <p>No events match your search.</p> : null}
          </div>
        )}

        {events.length && organisation && organisation.latitude && organisation.longitude ? (
          <div className="events-container-float" onClick={onMapPressed}>
            <MapView />
            <p className="events-container-float__text">
              {!isMapView ? 'Map view' : 'List view'}
            </p>
          </div>
        ) : null}
      </GridContainer>
    </div>
  );
};

export default Events;
